import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import Styles from "components/modal/Modal.module.scss";

export const ModalDialog = ({id, children, className}) => {
  let _attributes = {};
  if (id !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(Styles["modal__dialog"], className);
  } else {
    _attributes.className = Styles["modal__dialog"];
  }

  return (<div {..._attributes}>{children}</div>);
};

ModalDialog.propTypes = {
  id: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  children: PropTypes.node
};
